import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VImg,{staticClass:"peeps-img",attrs:{"width":"150","src":require("@/assets/img/PeepsAbove.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }